import { BaseMapper } from '@/core/mapper';

const schema = {
  id: {
    parseFrom: 'id',
  },
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  name: {
    parseFrom: 'attributes.name',
  },
};

class TradingName extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

TradingName.schema = schema;

export default TradingName;
